export const IMAGES = {
  defaultStrainPlaceholder: "https://d2xsxph8kpxj0f.cloudfront.net/310519663327876234/RBPh534jAfSh7iDqSuSqBr/default-strain-placeholder-aP33tTchwWabxjdxGZdo9J.webp",
  // Type-based default strain images (used when a strain has no custom image)
  defaultIndica: "https://d2xsxph8kpxj0f.cloudfront.net/310519663327876234/RBPh534jAfSh7iDqSuSqBr/default_indica_6fd00b43.png",
  defaultIndicaAlt: "https://d2xsxph8kpxj0f.cloudfront.net/310519663327876234/RBPh534jAfSh7iDqSuSqBr/default_indica_alt_322d92b8.png",
  defaultSativa: "https://d2xsxph8kpxj0f.cloudfront.net/310519663327876234/RBPh534jAfSh7iDqSuSqBr/default_sativa_78be2897.png",
  defaultSativaAlt: "https://d2xsxph8kpxj0f.cloudfront.net/310519663327876234/RBPh534jAfSh7iDqSuSqBr/default_sativa_alt_6eb11452.png",
  defaultHybrid: "https://d2xsxph8kpxj0f.cloudfront.net/310519663327876234/RBPh534jAfSh7iDqSuSqBr/default_hybrid_61580fb6.png",
  eventsHero: "https://d2xsxph8kpxj0f.cloudfront.net/310519663327876234/RBPh534jAfSh7iDqSuSqBr/events-hero-enDeRVnMbbVDBPR36exAFE.webp",
  logo: "https://d2xsxph8kpxj0f.cloudfront.net/310519663327876234/RBPh534jAfSh7iDqSuSqBr/logo-200_ed655163.webp",
  logoLarge: "https://d2xsxph8kpxj0f.cloudfront.net/310519663327876234/RBPh534jAfSh7iDqSuSqBr/logo-512_2c6e4966.webp",
  heroBg: "/manus-storage/city-hero-pins-final_bcb745fe.png",
  strainHero: "https://d2xsxph8kpxj0f.cloudfront.net/310519663327876234/RBPh534jAfSh7iDqSuSqBr/strain-hero-PVwHL3JkaWpZEx9cazMXwS.webp",
  communityHero: "https://d2xsxph8kpxj0f.cloudfront.net/310519663327876234/RBPh534jAfSh7iDqSuSqBr/community-hero-PHB7FoGt3wTZk7hvNTqqaz.webp",
  dispensaryHero: "https://d2xsxph8kpxj0f.cloudfront.net/310519663327876234/RBPh534jAfSh7iDqSuSqBr/dispensary-hero-KfxMgwcjxuJ3pBqDpfGEQk.webp",
  educationHero: "https://d2xsxph8kpxj0f.cloudfront.net/310519663327876234/RBPh534jAfSh7iDqSuSqBr/education-hero-VPRg4DumKPbKEPDyRPLDbU.webp",
  budtenderHero: "https://d2xsxph8kpxj0f.cloudfront.net/310519663327876234/RBPh534jAfSh7iDqSuSqBr/budtender-hero-Y74FzoQVXUrnMdySraqZXE.webp",
  orderSaveHero: "https://d2xsxph8kpxj0f.cloudfront.net/310519663327876234/RBPh534jAfSh7iDqSuSqBr/order-save-hero-Fz7HdN9JmEEzhsX2cov4Dv.webp",
};

export const STRAIN_TYPES = ["indica", "sativa", "hybrid"] as const;
export const PRODUCT_CATEGORIES = ["flower", "edible", "concentrate", "vape", "topical", "preroll", "tincture", "accessory"] as const;

export const EFFECTS = [
  "Relaxed", "Happy", "Euphoric", "Uplifted", "Sleepy", "Creative",
  "Hungry", "Focused", "Energetic", "Talkative", "Giggly", "Tingly",
  "Aroused", "Calm", "Motivated"
] as const;

export const FLAVORS = [
  "Earthy", "Sweet", "Citrus", "Berry", "Pine", "Woody", "Floral",
  "Spicy", "Herbal", "Tropical", "Grape", "Diesel", "Cheese",
  "Mint", "Vanilla", "Lavender", "Coffee", "Nutty", "Honey", "Skunk"
] as const;

export const TERPENES = [
  { name: "Myrcene", color: "#10b981", description: "Earthy, musky, herbal" },
  { name: "Limonene", color: "#f59e0b", description: "Citrus, lemon, orange" },
  { name: "Caryophyllene", color: "#ef4444", description: "Spicy, peppery, woody" },
  { name: "Linalool", color: "#8b5cf6", description: "Floral, lavender, sweet" },
  { name: "Pinene", color: "#22c55e", description: "Pine, fresh, sharp" },
  { name: "Humulene", color: "#f97316", description: "Hoppy, earthy, woody" },
  { name: "Terpinolene", color: "#06b6d4", description: "Herbal, floral, piney" },
  { name: "Ocimene", color: "#ec4899", description: "Sweet, herbal, woody" },
] as const;

export const US_STATES = [
  { name: "Alabama", code: "AL" }, { name: "Alaska", code: "AK" },
  { name: "Arizona", code: "AZ" }, { name: "Arkansas", code: "AR" },
  { name: "California", code: "CA" }, { name: "Colorado", code: "CO" },
  { name: "Connecticut", code: "CT" }, { name: "Delaware", code: "DE" },
  { name: "Florida", code: "FL" }, { name: "Georgia", code: "GA" },
  { name: "Hawaii", code: "HI" }, { name: "Idaho", code: "ID" },
  { name: "Illinois", code: "IL" }, { name: "Indiana", code: "IN" },
  { name: "Iowa", code: "IA" }, { name: "Kansas", code: "KS" },
  { name: "Kentucky", code: "KY" }, { name: "Louisiana", code: "LA" },
  { name: "Maine", code: "ME" }, { name: "Maryland", code: "MD" },
  { name: "Massachusetts", code: "MA" }, { name: "Michigan", code: "MI" },
  { name: "Minnesota", code: "MN" }, { name: "Mississippi", code: "MS" },
  { name: "Missouri", code: "MO" }, { name: "Montana", code: "MT" },
  { name: "Nebraska", code: "NE" }, { name: "Nevada", code: "NV" },
  { name: "New Hampshire", code: "NH" }, { name: "New Jersey", code: "NJ" },
  { name: "New Mexico", code: "NM" }, { name: "New York", code: "NY" },
  { name: "North Carolina", code: "NC" }, { name: "North Dakota", code: "ND" },
  { name: "Ohio", code: "OH" }, { name: "Oklahoma", code: "OK" },
  { name: "Oregon", code: "OR" }, { name: "Pennsylvania", code: "PA" },
  { name: "Rhode Island", code: "RI" }, { name: "South Carolina", code: "SC" },
  { name: "South Dakota", code: "SD" }, { name: "Tennessee", code: "TN" },
  { name: "Texas", code: "TX" }, { name: "Utah", code: "UT" },
  { name: "Vermont", code: "VT" }, { name: "Virginia", code: "VA" },
  { name: "Washington", code: "WA" }, { name: "West Virginia", code: "WV" },
  { name: "Wisconsin", code: "WI" }, { name: "Wyoming", code: "WY" },
] as const;
